export enum AdminOrderListItemAction {
  Cancel,
  FullRefund,
  MarkAsPaid,
  More,
  PartialRefund,
  Preview,
}
